export const timezoneQuery = () => {
    const query = `
      query {
        customerTimezone
      }
    `;
    return query;
  };

  export const updateTimezoneMutation = (timezone) => {
    let mutation = `
        mutation{
            updateSettings(
                timezone: ${JSON.stringify(timezone)}
            ){
                company{
                    customerAccount{
                        timezone
                    }
                }
            }
        }
    `
    return mutation
  }